import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity';

import { ProductOrderItem } from '../../models/order-request.model';
import { ItemPrice, getPriceFormat } from '../../utils/calculate-price-util';
import {
  OrderInventorySelectItemOrderActionTypes,
  OrderInventorySelectItemOrderActions
} from '../actions/order-select-item-inventory-order.actions';

export interface OrderInventorySelectItemOrderState extends EntityState<ProductOrderItem> {
  isLoading: boolean;
  skipUpdated: boolean;
}

export function sortList(a: ProductOrderItem, b: ProductOrderItem) {
  const aProductType = a.productType;
  const aArticleNo = a.articleNo;
  const bProductType = b.productType;
  const bArticleNo = b.articleNo;

  if (aProductType < bProductType) {
    return -1;
  }
  if (aProductType > bProductType) {
    return 1;
  }
  if (aArticleNo < bArticleNo) {
    return -1;
  }
  if (aArticleNo > bArticleNo) {
    return 1;
  }

  return 0;
}

export const adapter: EntityAdapter<ProductOrderItem> = createEntityAdapter<ProductOrderItem>({
  selectId: (orderInventorySelectItemOrderContent: ProductOrderItem) =>
    orderInventorySelectItemOrderContent.articleNo,
  sortComparer: sortList
});

export const initialOrderInventorySelectItemOrderState: OrderInventorySelectItemOrderState = adapter.getInitialState({
  isLoading: false,
  skipUpdated: false
});

export function OrderInventorySelectItemOrderReducers(
  state = initialOrderInventorySelectItemOrderState,
  action: OrderInventorySelectItemOrderActions
): OrderInventorySelectItemOrderState {
  switch (action.type) {
    case OrderInventorySelectItemOrderActionTypes.ORDER_INVENTORY_SELECT_ITEM_ORDER_ADD_ITEM:
      return adapter.upsertOne(action.payload, {
        ...state,
        skipUpdated: false
      });
    case OrderInventorySelectItemOrderActionTypes.ORDER_INVENTORY_SELECT_ITEM_ORDER_UPDATE_ITEM:
      return adapter.updateOne(
        {
          id: action.payload.articleNo,
          changes: { ...action.payload }
        },
        {
          ...state,
          skipUpdated: false
        }
      );
    case OrderInventorySelectItemOrderActionTypes.ORDER_INVENTORY_SELECT_ITEM_ORDER_UPDATE_ALL_ITEM:
      return adapter.updateMany(
        action.payload.map(v => {
          const item: ProductOrderItem = state.entities[v.articleNo];
          const itemPrice = new ItemPrice<ProductOrderItem>({ ...item, qty: v.qty }, 'qty');
          const amountExcVat = itemPrice.getTotalFrom('unitPriceExcVat');
          const vatAmount = itemPrice.getTotalFrom('unitPriceVat');
          const amount = getPriceFormat(amountExcVat.amount + vatAmount.amount);
          return {
            id: v.articleNo,
            changes: {
              ...item,
              qty: v.qty,
              amountExcVat,
              amount,
              totalVat: vatAmount,
              isAddItem: true
            }
          };
        }),
        {
          ...state,
          skipUpdated: false
        }
      );
    case OrderInventorySelectItemOrderActionTypes.ORDER_INVENTORY_SELECT_ITEM_ORDER_ADD_ALL_ITEM:
      return adapter.setAll(action.payload.itemList, {
        ...state,
        skipUpdated: action.payload.skipUpdated
      });
    case OrderInventorySelectItemOrderActionTypes.ORDER_INVENTORY_SELECT_ITEM_ORDER_REMOVE_ITEM:
      return adapter.removeOne(action.payload, {
        ...state
      });
    case OrderInventorySelectItemOrderActionTypes.ORDER_INVENTORY_SELECT_ITEM_ORDER_RESET:
      return adapter.removeAll({
        ...state
      });
    default: {
      return state;
    }
  }
}

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
